
/** 定数クラス */
export class Const {

    //#region  区分種別
    /** 区分種別 */
    static readonly KbnClass = class {
        /** 休日区分 */
        static readonly HOLIDAY_KBN = '01';
        /** 勤務区分 */
        static readonly WORKING_KBN = '02';
        /** 休暇区分 */
        static readonly VACATION_KBN = '03';
        /** 従業員権限 */
        static readonly AUTHORITY_KBN = '04';
        /** 雇用形態区分 */
        static readonly EMP_TYPE_KBN = '05';
        /** 在宅勤務区分 */
        static readonly TELEWORK_KBN = '06';
        /** 在宅勤務区分 */
        static readonly COST_KBN = '10';
    }
    //#endregion

    //#region 休日区分
    /** 休日区分 */
    static readonly HolidayKbn = class {
        /** 平日 */
        static readonly WEEKDAY = '10';
        /** 法定外休日 */
        static readonly HOLIDAY = '20';
        /** 法定休日 */
        static readonly LEGAL_HOLIDAY = '30';
    }
    //#endregion

    //#region 勤務区分
    /** 勤務区分 */
    static readonly WorkingKbn = class {
        /** 非勤務日 */
        static readonly NON_WORKINGDAY = '00';
        /** 通常勤務 */
        static readonly REGULAR_WORK = '10';
        /** シフト勤務2 */
        static readonly SHIFT_WORK_2ND = '20';
        /** シフト勤務3 */
        static readonly SHIFT_WORK_3RD = '30';
        /** 休日出勤 */
        static readonly HOLIDAY_WORK = '80';
        /** 個別設定シフト */
        static readonly INDIVIDUAL_SHIFT = '90';
    }
    //#endregion

    //#region 勤務区分サブコード
    /** 勤務区分サブコード */
    static readonly WorkingKbnScd = class {
        /** 平日用 勤務区分 */
        static readonly WRRKDAY_SCD = '10';
        /** 休日用 勤務区分 */
        static readonly HOLIDAY_SCD = '20';
    }
    //#endregion

    //#region 休暇区分
    /** 休暇区分 */
    static readonly VacationKbn = class {
        /** 設定なし */
        static readonly DEFAULT = '00';
        /** 有給・事前 */
        static readonly PAID_HOLIDAY_BEFORE = '11';
        /** 有給午前半休・事前 */
        static readonly PAID_HOLIDAY_AM_BEFORE = '12';
        /** 有給午後半休・事前 */
        static readonly PAID_HOLIDAY_PM_BEFORE = '13';
        /** 有給・当日 */
        static readonly PAID_HOLIDAY_THEDAY = '21';
        /** 有給午前半休・当日 */
        static readonly PAID_HOLIDAY_AM_THEDAY = '22';
        /** 有給午後半休・当日 */
        static readonly PAID_HOLIDAY_PM_THEDAY = '23';
        /** 振替休日 */
        static readonly TRANSFER_HOLIDAY = '31';
        /** 明休 */
        static readonly MIDNIGHT_VACATION = '32';
        /** シフト休 */
        static readonly SHIFT_VACATION = '33';
        /** 特休 */
        static readonly SPECIAL_HOLIDAY = '41';
        /** 特休AM */
        static readonly SPECIAL_HOLIDAY_AM = '42';
        /** 特休PM */
        static readonly SPECIAL_HOLIDAY_PM = '43';
        /** 夏季休暇 */
        static readonly SUMMER_VACATION = '44';
        /** 忌引き */
        static readonly BEREAVEMENT_LEAVE = '45';
        /** 欠勤 */
        static readonly ABSENCE = '51';
        /** 半欠勤AM */
        static readonly ABSENCE_AM = '52';
        /** 半欠勤PM */
        static readonly ABSENCE_PM = '53';
        /** 休業 */
        static readonly CLOSED = '61';
    }
    //#endregion

    //#region 経費区分
    /** 経費区分 */
    static readonly CostKbn = class {
        /** 公共交通機関 */
        static readonly TRANSPORT_COST = '01';
        /** タクシー */
        static readonly ACCOMONDATION_FEE = '10';
        /** 日当 */
        static readonly DAILY_ALLOWANCE = '11';
        /** 宿泊 */
        static readonly TAXI = '12';
        /** その他交通費 */
        static readonly OTHER_TRANSPORT_COST = '13';
        /** その他 */
        static readonly OTHER = '99';
    }
    //#endregion

    //#region 遅刻早退区分
    /** 遅刻早退区分 */
    static readonly LateEarlyKbn = class {
        /** 遅刻 */
        static readonly LATE = '10';
        /** 早退 */
        static readonly LEAVE_EARLY = '20';
        /** 電車遅延 */
        static readonly TRAIN_DELAY = '30';
    }
    //#endregion

    //#region 権限
    /** 権限 */
    static readonly Authority = class {
        /** 総務 */
        static readonly WORKING_HOURS_ADMIN = '10';
        /** 業務管理 */
        static readonly BUSINESS_ADMIN = '20';
        /** 管理職 */
        static readonly MANAGER = '30';
        /** リーダー */
        static readonly LEADER = '40';
        /** 営業 */
        static readonly SALES = '50';
    }
    //#endregion

    //#region 雇用形態区分
    /** 雇用形態区分 */
    static readonly Emptype = class {
        /** 役員 */
        static readonly EXECTIVE = "05";
        /** 正社員 */
        static readonly REGULAR = "10";
        /** 契約社員 */
        static readonly CONTRACT = "20";
    }
    //#endregion

    //#region 在宅勤務
    /** 在宅勤務 */
    static readonly TeleWork = class {
        /** 設定なし */
        static readonly DEFAULT = '00';
        /** 在宅勤務・終日 */
        static readonly TELEWORK_ALL = '11';
        /** 在宅勤務・一部 */
        static readonly TELEWORK_PART = '12';
        /** 在宅勤務・予定 */
        static readonly TELEWORK_SCHEDULE = '20';
    }
    //#endregion

    //#region　勤務表 月次ステータス
    /**勤務表 月次ステータス */
    static readonly MonthlyStatus = class {
        /** 新規 */
        static readonly NEW = '00';
        /** 未登録 */
        static readonly UNREGISTERED = '01';
        /** 作成中 */
        static readonly MAKING = '10';
        /** 差戻し */
        static readonly REMAND = '11';
        /** 承認待ち */
        static readonly AWAITING_APPROVAL = '20';
        /** 承認済み */
        static readonly APPROVED = '30';
        /** 締め済み */
        static readonly CLOSING = '40';
    }
    //#endregion

    //#region 勤務表　日次ステータス
    /** 勤務表　日次ステータス */
    static readonly DailyStatus = class {
        /** 新規 */
        static readonly NEW = '00';
        /** 作成中 */
        static readonly MAKING = '10';
        /** 差戻し */
        static readonly REMAND = '11';
        /** 承認待ち */
        static readonly AWAITING_APPROVAL = '20';
        /** 承認済み */
        static readonly APPROVED = '30';
        /** 締済 */
        static readonly CLOSING = '40';
    }
    //#endregion

    //#region 申請ステータス 
    /** 申請ステータス */
    static readonly RequestStatus = class {
        /** 作成中 */
        static readonly MAKING = '10';
        /** 差戻し */
        static readonly REMAND = '11';
        /** 承認待ち */
        static readonly AWAITING_APPROVAL = '20';
        /** 承認済み */
        static readonly APPROVED = '30';
        /** 締済 */
        static readonly CLOSING = '40';
    }
    //#endregion

    //#region  申請区分
    /** 申請区分 */
    static readonly RequestKbn = class {
        /** 定期申請情報 */
        static readonly TRAIN_PASS = 'M13';
        /** 勤務表(t_request.RequestKbnには存在しない。コード内分類用) */
        static readonly MONTHLY_ATTENDANCE_SHEET = 'W01';
        /** 経費一覧 */
        static readonly COST_LIST = 'W02';
        /** 勤務区分変更 */
        static readonly WORKING = 'W11';
        /** 休暇 */
        static readonly VACATION = 'W21';
        /** 遅刻 */
        static readonly LATE = 'W31';
        /** 電車遅延 */
        static readonly TRAIN_DELAY = 'W32';
        /** 早退 */
        static readonly LEAVE_EARLY = 'W33';
    }
    //#endregion

    //#region  ログ情報 チェック対象
    /** ログ情報 チェック対象 */
    static readonly LogTarget = class {
        /** 勤務時間 */
        static readonly WORKINGLIST = '勤務表';
        /** 勤務時間 */
        static readonly WORKINGTIME = '勤務時間';
        /** 勤務申請 */
        static readonly REQUEST_WORK = '勤務申請';
        /** 休暇申請 */
        static readonly REQUEST_VACATION = '休暇申請';
        /** 遅早退申請１ */
        static readonly REQUEST_LATE1 = '遅早退申請１';
        /** 遅早退申請2 */
        static readonly REQUEST_LATE2 = '遅早退申請２';
        /** 明細変更 */
        static readonly DETAIL_CHANGE = '明細変更';
        /** 明細変更 */
        static readonly COSTLIST = '経費一覧';
    }
    //#endregion

    //#region 経費月次ステータス
    /** 経費月次ステータス */
    static readonly CostMonthlyStatus = class {
        /** 新規 */
        static readonly NEW = '00';
        /** 未登録 */
        static readonly UNREGISTERED = '01';
        /** 作成中 */
        static readonly MAKING = '10';
        /** 差戻し */
        static readonly REMAND = '11';
        /** 承認待ち */
        static readonly AWAITING_APPROVAL = '20';
        /** 承認済み */
        static readonly APPROVED = '30';
        /** 締済 */
        static readonly CLOSING = '40';
    }
    //#endregion

    //#region 経費明細ステータス
    /** 経費明細ステータス */
    static readonly CostDetailStatus = class {
        /** 新規 */
        static readonly NEW = '00';
        /** 未登録 */
        static readonly UNREGISTERED = '01';
        /** 作成中 */
        static readonly MAKING = '10';
        /** 差戻し */
        static readonly REMAND = '11';
        /** 承認待ち */
        static readonly AWAITING_APPROVAL = '20';
        /** 承認済み */
        static readonly APPROVED = '30';
        /** 締済 */
        static readonly CLOSING = '40';

    }
    //#endregion

    //#region 交通費
    /** 交通費 */
    static readonly TransPortCost = class {

        /** 経路区分 */
        static readonly commuteRouteKbn = class {

            /** 通勤経路 */
            static readonly INSIDE = '01';

            /** 通勤経路外 */
            static readonly OUTSIDE = '02';
        }

        /** 検索順区分 */
        static readonly orderKbn = class {
            /** 料金順 */
            static readonly AMOUNT = '01';

            /** 時間順 */
            static readonly TIME = '02';

        }

        /** 往復区分 */
        static readonly roundKbn = class {
            /** 片道 */
            static readonly ONE_WAY = '01';

            /** 往復 */
            static readonly ROUND_TRIP = '02';

        }

        /** バスオプション */
        static readonly busOption = class{
            /** 路線バス含まない */
            static readonly EXCLUDE = '0';

            /** 路線バス含む */
            static readonly INCLUDE = '1';

        }
    }
    //#endregion

    //#region 定期券申請ステータス
    /** 定期券申請ステータス */
    static readonly TrainPassStatus = class {
        /** 新規 */
        static readonly NEW = '00';
        /** 未登録 */
        static readonly UNREGISTERED = '01';
        /** 作成中 */
        static readonly MAKING = '10';
        /** 差戻し */
        static readonly REMAND = '11';
        /** 承認待ち */
        static readonly AWAITING_APPROVAL = '20';
        /** 承認済み */
        static readonly APPROVED = '30';
        /** 締済 */
        static readonly CLOSING = '40';
    }
    //#endregion

    //#region 駅探APIステータス
    /** 駅探APIステータス */
    static readonly EkitanStatus = class {

        static readonly STATUSNM_0 = '正常';
        static readonly STATUSNM_1 = '乗車駅指定エラー';
        static readonly STATUSNM_2 = '下車駅指定エラー';
        static readonly STATUSNM_3 = '該当列車・便無し';
        static readonly STATUSNM_4 = '乗車駅と下車駅が同じ';
        static readonly STATUSNM_7 = '経由駅指定エラー';
        static readonly STATUSNM_100 = 'パラメータ指定エラー';
        static readonly STATUSNM_200 = '内部エラー';
        static readonly STATUSNM_220 = 'パラメータ指定エラー';
        static readonly STATUSNM_DEFAULT = 'ステータス異常';
    }
    //#endregion

    //#region 駅探URLパラメータ
    /** 駅探URLパラメータ */
    static readonly EkitanURLParam = class {

        /** 駅候補出力 */
        static readonly NorikaeSearchStation = class {

            //#region AN　エリア番号
            /** エリア番号 */
            static readonly AN = class {

                /** 全国 */
                static readonly JAPAN_NATIONAL = '-1';
                /** 首都圏 */
                static readonly CAPITAL_AREA = '0';
                /** 関西 */
                static readonly KANSAI = '1';
                /** 東海 */
                static readonly TOKAI = '2';
                /** 北海道 */
                static readonly HOKKAIDO = '3';
                /** 東北 */
                static readonly TOHOKU = '4';
                /** 北陸 */
                static readonly HOKURIKU = '5';
                /** 甲信越 */
                static readonly KOSHINETSU = '6';
                /** 中国 */
                static readonly CHUGOKU = '7';
                /** 四国 */
                static readonly SHIKOKU = '8';
                /** 九州 */
                static readonly KYUSHU = '9';

            }
            //#endregion

            //#region CHAR 文字コード
            /**  CHAR 文字コード */
            static readonly CHAR = class {

                /**euc-jp*/
                static readonly EUC_JC = '0';
                /**Shift_JIS*/
                static readonly SHIF_JIS = '1';
                /**utf-8*/
                static readonly UTF_8 = '2';

            }
            //#endregion

            //#region NF 略称有無
            /**  NF 略称有無 */
            static readonly NF = class {

                /**正式名称*/
                static readonly FULL_NAME = '0';
                /**略称*/
                static readonly SHORT_NAME = '1';

            }
            //#endregion

            //#region RB 路線バス指定
            /**  RB 路線バス指定 */
            static readonly RB = class {

                /**路線バス　含まない*/
                static readonly EXCLUDE_BUS = '0';
                /**路線バス　含む*/
                static readonly INCLUDE_BUS = '1';
                /**路線バス　のみ*/
                static readonly ONLY_BUS = '2';

            }
            //#endregion

            //#region CO 複合名称出力 RB=0（省略時含む）の時は無視される
            /**  CO 複合名称出力 ※RB=0（省略時含む）の時は無視される*/
            static readonly CO = class {

                /**停留所名とバス会社を分離した情報を出力しない*/
                static readonly NOT_OUTPUT = '0';
                /**停留所名とバス会社を分離した情報を出力する*/
                static readonly OUTPUT = '1';

            }
            //#endregion

            //#region OF 出力形式指定
            /**  OF 出力形式指定 */
            static readonly OF = class {

                /**XML形式*/
                static readonly XML = '0';
                /**JSON形式*/
                static readonly JSON = '1';
                /**JSON形式（簡略形式）*/
                static readonly SIMPLE_JSON = '3';

            }
            //#endregion
        }

        /** 乗換案内 */
        static readonly Norikae = class {

            //#region DW　曜日
            /**  DW　曜日 */
            static readonly DW = class {

                /** 当日 */
                static readonly TODAY = '-1';
                /** 平日 */
                static readonly WORK_DAY = '0';
                /** 土曜 */
                static readonly SATURDAY = '1';
                /** 日曜 */
                static readonly SUNDAY = '2';

            }
            //#endregion

            //#region　RP　優先指定
            /**  RP　優先指定 */
            static readonly RP = class {

                /** 時刻 */
                static readonly TIME = '0';
                /** 料金 */
                static readonly CHARGE = '1';
                /** 乗換回数 */
                static readonly TRANSFER_COUNT = '2';
                /** 定期運賃 6ヶ月定期券の合計金額の安い順*/
                static readonly COMMUTER_PASS = '3';
                /** 定期区間外運賃 定期区間を考慮した料金計算を行い、合計金額の安い順*/
                static readonly OUTSIDE_COMMUTER_PASS = '4';

            }
            //#endregion

            //#region　PN　出力候補数
            /**  PN　出力候補数 */
            static readonly PN = class {

                /** 3件出力 */
                static readonly COUNT_3 = '3';
                /** 5件出力 */
                static readonly COUNT_5 = '5';
                /** 10件出力 */
                static readonly COUNT_10 = '10';
                /** 20件出力*/
                static readonly COUNT_20 = '20';

            }
            //#endregion

            //#region　SR　発着指定
            /**  SR　発着指定*/
            static readonly SR = class {

                /** 発指定 */
                static readonly DEPARTURE = '0';
                /** 着指定 */
                static readonly ARRIVAL = '1';
                /** 始発検索 */
                static readonly FIRST_TRAIN = '3';
                /** 今乗る検索*/
                static readonly NOW = '7';

            }
            //#endregion

            //#region　EP 短距離有料特急有無
            /**  EP 短距離有料特急有無*/
            static readonly EP = class {

                /** 無 */
                static readonly NONE = '0';
                /** 有 */
                static readonly PRESENCE = '1';
                /** 新幹線定期出力用*/
                static readonly PASS_SUPER_EXPRESS = '7';

            }
            //#endregion

            //#region AN　エリア番号
            /** エリア番号 */
            static readonly AN = class {

                /** 全国 */
                static readonly JAPAN_NATIONAL = '-1';
                /** 首都圏 */
                static readonly CAPITAL_AREA = '0';
                /** 関西 */
                static readonly KANSAI = '1';
                /** 東海 */
                static readonly TOKAI = '2';
                /** 北海道 */
                static readonly HOKKAIDO = '3';
                /** 東北 */
                static readonly TOHOKU = '4';
                /** 北陸 */
                static readonly HOKURIKU = '5';
                /** 甲信越 */
                static readonly KOSHINETSU = '6';
                /** 中国 */
                static readonly CHUGOKU = '7';
                /** 四国 */
                static readonly SHIKOKU = '8';
                /** 九州 */
                static readonly KYUSHU = '9';

            }
            //#endregion

            //#region CHAR 文字コード
            /**  CHAR 文字コード */
            static readonly CHAR = class {

                /**euc-jp*/
                static readonly EUC_JC = '0';
                /**Shift_JIS*/
                static readonly SHIF_JIS = '1';
                /**utf-8*/
                static readonly UTF_8 = '2';

            }
            //#endregion

            //#region NF 略称有無
            /**  NF 略称有無 */
            static readonly NF = class {

                /**正式名称*/
                static readonly FULL_NAME = '0';
                /**略称*/
                static readonly SHORT_NAME = '1';

            }
            //#endregion

            //#region TP　乗り換え時間指定
            /**  TP　乗り換え時間指定 */
            static readonly TP = class {

                /**標準*/
                static readonly STANDARD = '0';
                /**長めの時間*/
                static readonly LONGER = '1';
                /**短めの時間*/
                static readonly SHORTER = '2';
                /**もっと長めの時間*/
                static readonly LONGER_MORE = '4';

            }
            //#endregion

            //#region CP 定期運賃計算
            /**  CP　定期運賃計算 */
            static readonly CP = class {

                /**定期出力なし*/
                static readonly NONE = '0';
                /**通勤定期出力あり*/
                static readonly OUTPUT = '1';

            }
            //#endregion

            //#region BS　行先表示指定
            /**  BS　行先表示指定 */
            static readonly BS = class {

                /**表示なし*/
                static readonly DISPLAY_NONE = '0';
                /**表示する*/
                static readonly DISPLAY = '1';

            }
            //#endregion

            //#region TI　列車優先指定
            /**  TI　列車優先指定 */
            static readonly TI = class {

                /**無指定*/
                static readonly NONE = '0';
                /**のぞみ非優先*/
                static readonly NOZOMI = '1';
                /**はやぶさ非優先*/
                static readonly HAYABUSA = '2';
                /**みずほ非優先*/
                static readonly MIZUHO = '4';
                /**のぞみ・はやぶさ・みずほ非優先*/
                static readonly EVERY = '7';

            }
            //#endregion

            //#region DC　特急、新幹線の料金種別指定
            /**  DC　特急、新幹線の料金種別指定 指定した座席種別がない列車が案内される場合は別の座席種別で計算する*/
            static readonly DC = class {

                /**自由席料金で計算する*/
                static readonly NONE_RESERVED = '0';
                /**指定席料金で計算する*/
                static readonly RESERVED = '1';
                /**グリーン料金で計算する*/
                static readonly SECOND_CLASS = '2';
                /**グランクラス料金で計算する*/
                static readonly FIRST_CLASS = '3';

            }
            //#endregion

            //#region AIR　航空会社優先指定
            /**  AIR　航空会社優先指定*/
            static readonly AIR = class {

                /**指定なし*/
                static readonly NONE = '0';
                /**JAL*/
                static readonly JAL = '1';
                /**ANA*/
                static readonly ANA = '2';
                /**SKY/ADO/その他*/
                static readonly OTHER = '4';

            }
            //#endregion

            //#region FM　前次検索モード
            /**  FM　前次検索モード*/
            static readonly FM = class {

                /** 指定なし*/
                static readonly NONE = '0';
                /**発駅・停留所での次の列車・便*/
                static readonly DEPARTURE_NEXT = '1';
                /**発駅・停留所での前の列車・便*/
                static readonly DEPARTURE_PREV = '2';
                /**着駅・停留所での次の列車・便*/
                static readonly ARRIVAL_NEXT = '3';
                /**着駅・停留所での前の列車・便*/
                static readonly ARRIVAL_PREV = '4';

            }
            //#endregion

            //#region FX　経路指定検索モード
            /**  FX　経路指定検索モード*/
            static readonly FX = class {

                /** 経路を指定しない*/
                static readonly NONE = '0';
                /**経路指定検索 単体モード。指定した経路のみを出力する*/
                static readonly ONLY = '1';
                /**経路指定検索 混合モード。指定した経路を、通常の乗り換え案内の結果に必ず含めて出力する*/
                static readonly MIX = '2';

            }
            //#endregion

            //#region WL　徒歩経路制限指定
            /**  WL　徒歩経路制限指定*/
            static readonly WL = class {

                /** 徒歩経路を指定しない*/
                static readonly NONE = '0';
                /**20分以上の徒歩を使う経路を出力しない。*/
                static readonly WITHIN_20M = '-1';

                /**5～30：設定された時間(単位：分)以上の徒歩経路を使った経路を出力しない*/
                
            }
            //#endregion

            //#region CV　経由駅・停留所乗り換え指定
            /**  CV　経由駅・停留所乗り換え指定*/
            static readonly CV = class {

                /** 無指定*/
                static readonly NONE = '0';
                /**経由駅・停留所で乗り換える*/
                static readonly TRANSFER = '1';

            }
            //#endregion

            //#region RB 路線バス指定
            /**  RB 路線バス指定 */
            static readonly RB = class {

                /**路線バス　含まない*/
                static readonly EXCLUDE_BUS = '0';
                /**路線バス　含む*/
                static readonly INCLUDE_BUS = '1';
                /**路線バス　のみ*/
                static readonly ONLY_BUS = '2';

            }
            //#endregion

            //#region OF 出力形式指定
            /**  OF 出力形式指定 */
            static readonly OF = class {

                /**XML形式*/
                static readonly XML = '0';
                /**JSON形式*/
                static readonly JSON = '1';
                /**JSON形式（簡略形式）*/
                static readonly SIMPLE_JSON = '3';

            }
            //#endregion

            //#region ICF IC運賃表示形式
            /**  ICF IC運賃表示形式 */
            static readonly ICF = class {

                /**きっぷの運賃と異なるときに出力する。*/
                static readonly PR_0 = '0';
                /**きっぷ運賃の項目（fare,basicFare,charge等）にIC運賃を出力する。きっぷの運賃は出力しない。但し、IC利用区間外はきっぷの運賃を出力する。*/
                static readonly PR_1 = '1';
                /**常に並行出力。IC利用区間外の場合は、IC運賃やIC料金の項目にきっぷの運賃を出力する*/
                static readonly PR_2 = '2';
                /**JIC運賃を出力しない。常にきっぷ運賃を出力する。*/
                static readonly PR_3 = '3';

            }
            //#endregion

            //#region ICC IC料金表示形式
            /**  ICC IC料金表示形式。 ICFパラメータが「１」もしくは「3」の場合、ICCパラメータの指定は無効としIC料金を出力しない。 */
            static readonly ICC = class {

                /**IC料金を出力しない*/
                static readonly NONE = '0';
                /**IC料金を出力する*/
                static readonly OUTPUT = '1';

            }
            //#endregion

            //#region TU 利用交通機関指定
            /** TU 利用交通機関指定。飛行機、新幹線、特急の各交通機関の利用の有無を指定する。*/
            static readonly TU = class {

                /**指定無*/
                static readonly NONE = '00000000';
                /**在来線のみ*/
                static readonly CONVERTIONAL_LINES = '00222220';
                /**飛行機と新幹線を除く*/
                static readonly EXCLUDE_AIRPLANE_SUPEREXPRESS = '00220000';
                /**飛行機を除く*/
                static readonly EXCLUDE_AIRPLANE = '00200000';
                /**新幹線を除く*/
                static readonly EXCLUDE_SUPEREXPRESS = '000020000';

            }
            //#endregion
        }
    }
    //#endregion
}
